export enum QuotesDashboardDateRange {
  MONTH_TO_DATE = 'monthToDate',
  PREVIOUS_MONTH = 'previousMonth',
  PREVIOUS_YEAR = 'previousYear',
  YEAR_TO_DATE = 'yearToDate',
}

export enum QuotesDashboardQuoteType {
  CUSTOMER = 'customer',
  VENDOR = 'vendor',
}

export enum QuotesVsOrdersView {
  COSTS = 'costs',
  QUANTITY = 'quantity',
}
